import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Route, Routes, useLocation, useNavigate, useParams
} from 'react-router-dom'
import _ from 'lodash'

import Header from '@pages/companies/header'
import ChooseFiles from '@pages/uploadExams/chooseFiles'
import ConcludedFeedback from '@pages/uploadExams/concludedFeedback'

import Dropzone from '@components/dropzone'
import PrimaryButton from '@components/inputs/button/primaryButton'
import SecondaryButton from '@components/inputs/button/secondaryButton'
import ContinueModal from '@components/modal/continueModal'
import FilterBar from './filterBar'

import {
  Container, DropContainer, DropArea, ButtonArea
} from './styles'

import colors from '@settings/styleSettings'
import { clearBeneficiary as clearBeneficiaryAction, saveBeneficiariesExams as saveBeneficiariesExamsAction } from '@actions/beneficiary'
import { bindActionCreators } from 'redux'
import showToast from '@util/ToastUtil'

const UploadExams = ({ clearBeneficiary, saveBeneficiariesExams }) => {
  const [files, setFiles] = useState([])
  const [concludeModal, setConcludeModal] = useState(false)
  const [cancelModal, setCancelModal] = useState(false)
  const [filesData, setFilesData] = useState(Array(files.length))
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  const { insurance } = useParams()
  const { pathname } = useLocation()

  const clear = () => {
    console.log('Limpando dados de beneficiários')
    clearBeneficiary()
    setFilesData(Array(files.length))
    setFiles([])
  }

  useEffect(() => {
    console.log('Componente montado - limpando dados iniciais')
    clear()
    return clear()
  }, [])

  useEffect(() => {
    console.log('Arquivos alterados:', files)
    console.log('Dados dos arquivos após mudança:', filesData)
    setFilesData(Array(files.length))
  }, [files])

  // Log sempre que filesData mudar
  useEffect(() => {
    console.log('FilesData atualizado:', filesData)
  }, [filesData])

  const checkAllFilesConcluded = () => _.every(filesData, ({ confirmed }) => confirmed)

  const onClickNext = () => {
    console.log('Botão próximo/concluir clicado')
    if (pathname.endsWith('revisar')) {
      console.log('Checando se todos os arquivos foram confirmados')
      if (checkAllFilesConcluded()) {
        console.log('Todos arquivos confirmados, abrindo modal de conclusão')
        setConcludeModal(true)
      } else {
        console.log('Nem todos os arquivos foram confirmados')
        showToast('error', 'É necessário confirmar todos os beneficiários')
      }
    } else {
      console.log('Navegando para tela de revisão')
      navigate('revisar')
    }
  }

  const onConfirm = () => {
    console.log('Usuário confirmou envio dos exames')
    setLoading(true)

    console.log('Preparando dados para envio')
    console.log('FilesData antes do envio:', filesData)

    const formData = new FormData()
    const json = JSON.stringify(_.map(filesData, (fileData) => {
      console.log('Processando fileData:', fileData)
      return {
        ...fileData,
        examType: fileData.examType.id
      }
    }))

    console.log('JSON preparado para envio:', json)

    const blob = new Blob([json], {
      type: 'application/json'
    })
    formData.append('beneficiaryExams', blob)

    console.log('Adicionando arquivos ao FormData')
    _.forEach(files, (file) => {
      console.log('Adicionando arquivo:', file.name, 'tipo:', file.type, 'tamanho:', file.size)
      formData.append('files', file)
    })

    console.log('Enviando FormData para o backend')
    saveBeneficiariesExams(
      formData,
      () => {
        console.log('Retorno bem-sucedido do backend')
        setLoading(false)
        navigate('concluir')
        setConcludeModal(false)
      }
    )
  }

  const goBack = () => {
    console.log('Voltando para tela de acompanhamento')
    navigate(`/${insurance}/acompanhamento`)
  }

  const stepBack = () => {
    console.log('Voltando uma etapa')
    navigate(-1)
    clearBeneficiary()
    setFilesData(Array(files.length))
  }

  return (
    <Container>
      <Header />
      <DropArea>
        <FilterBar
          pathname={pathname}
          cancel={() => setCancelModal(true)}
        />

        <DropContainer>
          <Routes>
            <Route
              path="/"
              element={<Dropzone files={files} setFiles={setFiles} />}
            />
            <Route
              path="/revisar"
              element={(
                <ChooseFiles
                  files={files}
                  setFiles={setFiles}
                  filesData={filesData}
                  setFilesData={setFilesData}
                />
              )}
            />
            <Route
              path="/concluir"
              element={<ConcludedFeedback files={files.length} />}
            />
          </Routes>
        </DropContainer>

        {files.length > 0 && !pathname.endsWith('concluir') && (
          <ButtonArea>
            {(pathname.endsWith('revisar')
              || pathname.endsWith('concluir')) && (
                <SecondaryButton onClick={stepBack}>
                  Voltar
                </SecondaryButton>
            )}
            <PrimaryButton onClick={onClickNext} style={{ float: 'right' }}>
              {pathname.endsWith('revisar') ? 'Concluir' : 'Avançar'}
              <span
                className="material-symbols-outlined"
                style={{
                  color: colors.titleStrongWhite,
                  float: 'right',
                  marginLeft: 10,
                }}
              >
                {pathname.endsWith('revisar') ? 'check' : 'chevron_right'}
              </span>
            </PrimaryButton>
          </ButtonArea>
        )}
      </DropArea>
      <ContinueModal
        isOpen={concludeModal}
        setClose={() => setConcludeModal(false)}
        title="Concluir importação de exames?"
        subtitle="Essa ação não pode ser desfeita."
        loading={loading}
        primaryButtonLabel="Sim, concluir"
        secondaryButtonLabel="Voltar"
        onClickPrimary={onConfirm}
      />
      <ContinueModal
        isOpen={cancelModal}
        setClose={() => setCancelModal(false)}
        title="Cancelar importação de exames?"
        subtitle="Essa ação não pode ser desfeita."
        primaryButtonLabel="Sim, concluir"
        secondaryButtonLabel="Voltar"
        onClickPrimary={goBack}
      />
    </Container>
  )
}

UploadExams.propTypes = {
  clearBeneficiary: PropTypes.func.isRequired,
  saveBeneficiariesExams: PropTypes.func.isRequired
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    clearBeneficiary: clearBeneficiaryAction,
    saveBeneficiariesExams: saveBeneficiariesExamsAction
  },
  dispatch
)

export default connect(null, mapDispatchToProps)(UploadExams)
